import { DateTime } from "luxon";
import { SortConfig, SortDirection } from "../types/common";
import { MILLISECONDS_BY_TIME_UNIT } from "../constants/dates";

export const captialize = (str: string): string => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const capitializeAndRemoveUnderScore = (string:string):string=>{
  if(!string){
    return ""
  }

  const parsedString = string.replace(/_/g," ")
  return captialize(parsedString)

}

export const delay = (ms = 300) => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};

const toggleSortDirection = (sortDirection: SortDirection) => {
  return sortDirection === SortDirection.desc
    ? SortDirection.asc
    : SortDirection.desc;
};

export const changeSort = (sortBy: string, previousSortConfig: SortConfig) => {
  let sortDirection;

  if (previousSortConfig.sortBy !== sortBy) {
    sortDirection = SortDirection.asc;
  } else {
    sortDirection = toggleSortDirection(previousSortConfig.sortDirection ?? SortDirection.asc);
  }

  return { sortBy, sortDirection };
};

export const getYearsFromUtc = (date: string) => {
  return Math.floor(DateTime.now().diff(DateTime.fromISO(date), 'year').years)
};

export const getRouteLink = (route: string) => {
  const [path] = route.split(":");
  return path;
};

export const getTimeDiffInMS = (  timeAmount: string,  timeUnit: string) : number => {
  const timeAmountNumber = Number(timeAmount);
  const timeUnitNumber = MILLISECONDS_BY_TIME_UNIT[timeUnit];
  const result = timeUnitNumber * timeAmountNumber;
  return result;
};
